angular.module('impactx.purchaserequest').controller('SimplePurchaseRequestListCtrl', SimplePurchaseRequestListCtrl);

SimplePurchaseRequestListCtrl.$inject = ['$scope', '$routeParams', 'dataGen', 'selectedListItems', '$mdDialog'];

function SimplePurchaseRequestListCtrl($scope, $routeParams, dataGen, selectedListItems, $mdDialog) {
    var ctrl = this;

    ctrl.getDetailLink = function () {
        return "purchaserequestdetail/" + selectedListItems.getFirstSelectedItem().prhId + "/" + selectedListItems.getFirstSelectedItem().id;
    };

    ctrl.isGRNTotalPossible = function () {
        return selectedListItems.isSingleSelection() && selectedListItems.getFirstSelectedItem().canGRNTotal.value;
    };

    ctrl.editGRNTotal = function () {
        var tempScope = {};
        var selected = selectedListItems.getFirstSelectedItem().pohIds.value;
        dataGen.getData(tempScope, {selected: [selected]}, "/deliverynote/purchaseorderlist/viewHead").then(function () {
            $mdDialog.show({
                templateUrl: "modules/deliverynote/templates/deliverynote-total.tmpl.html",
                controller: "DeliveryNoteTotalCtrl",
                controllerAs: "deliveryNoteTotalCtrl",
                parent: angular.element(document.body),
                targetEvent: event,
                clickOutsideToClose: false,
                locals: {
                    withSerialNumber: false,
                    data: tempScope.data,
                    trns: tempScope.trns,
                    count: selectedListItems.getFirstSelectedItem().PriCount,
                    sum: selectedListItems.getFirstSelectedItem().PRISum
                }
            });
        });
    };

    ctrl.getDelNoteLink = function() {
        return "deliverynote";
    };

    ctrl.canGRNSingle = function() {
        return selectedListItems.isSingleSelection() &&
            selectedListItems.getFirstSelectedItem().canGRNSingle.value;
    };

    ctrl.canComplain = function() {
        return selectedListItems.isSingleSelection() &&
            selectedListItems.getFirstSelectedItem().pohIds.value &&
            selectedListItems.getFirstSelectedItem().pohIds.value.length
    };

    ctrl.getComplainLink = function() {
        return "simplecomplaint/"+selectedListItems.getFirstSelectedItem().pohIds.value[0].id;
    };

    var buttonDefinition = [
        {
            label: "details",
            linkFunction: ctrl.getDetailLink,
            type: 'link',
            condition: selectedListItems.isSingleSelection,
            process: 'StatusSimple'
        },
        {
            label: "grnTotal",
            action: ctrl.editGRNTotal,
            condition: ctrl.isGRNTotalPossible,
            process: 'EditDeliveryNote'
        },
        {
            label: "createDelNoteSingle",
            linkFunction: ctrl.getDelNoteLink,
            type:'link',
            condition:  ctrl.canGRNSingle,
            process: 'EditDeliveryNote'
        },
        {
            label: "simplecomplaint",
            linkFunction: ctrl.getComplainLink,
            type:'link',
            condition:  ctrl.canComplain,
            process: 'ViewDeliveryComplaint'
        }
    ];

    this.meta = {
        rowTemplate: 'modules/status/purchaserequest/templates/simplepurchaserequestlist.row.tmpl.html',
        headerTemplate: 'modules/status/purchaserequest/templates/simplestatusheadersummary.tmpl.html',
        isSelectAble: true,
        endpoint: '/purchaserequest/simple/list',
        ctrl: this,
        id: "simplepurchaserequest",
        buttonDefinition: buttonDefinition,
        excelExport: true
    };

    this.getMeta = function () {
        return this.meta;
    };
}
